
import * as React from "react";
import { Fixture } from "../records/Fixture";
import { FixtureListElementView } from "./FixtureListElementView";
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from "@material-ui/core";
import FixtureScoreboardContainer from "../../fixture-details/FixtureScoreboardContainer";
import JwtUtils from "../../../utils/JwtUtils";
import CookieUtils from "../../../utils/CookieUtils";

export interface ICompetitionFixturesViewProps {
    competitionName: string,
    fixtures: DisplayedFixture[],
    fixtureClicked: (num: number, bool?: boolean) => void
    getLiveScoreboardId: () => number
}

export interface ICompetitionFixturesViewState {
    isAdmin: boolean;
}

export interface DisplayedFixture {
    fixture: Fixture,
    displayed: boolean
}

export class CompetitionFixturesView extends React.Component<ICompetitionFixturesViewProps, ICompetitionFixturesViewState> {

    constructor(props: any) {
        super(props);
        this.state = this.getInitialState();
    }

    private getInitialState() {
        return {isAdmin: this.isAdmin(JwtUtils.getJWTPayload(CookieUtils.getCookie("GameScorekeeper"))) || localStorage.getItem("debug-support") === 'true'}
    }

    private isAdmin(cookie: any) : boolean {
        if(!cookie) {
            return false;
        }
        const supporters: string[] = ["nicholas", "marie","mikkel", "simon", "mia", "narcis", "lucia"];
        return cookie.admin || supporters.includes(cookie.sub);
    }
    
    private timeFormatter(millis: number) {
        millis = millis > 0 ? millis : 0;
        let delta = millis / 1000;
        const days = Math.floor(delta / 86400);
        delta -= days * 86400;
    
        const hours = Math.floor(delta / 3600) % 24;
        delta -= hours * 3600;
    
        const minutes = Math.ceil(delta / 60) % 60;
        delta -= minutes * 60;
    
        return (days ? `${days} day${days !== 1 ? "s" : ""} ` : "")
          + (days || (!days && hours) ? `${days ? " " : ""}${hours} hour${hours !== 1 ? "s" : ""}` : "")
          + `${hours ? " " : ""}${minutes} minute${minutes !== 1 ? "s" : ""}`;
      }

    public render() {
        const fixtures = this.props.fixtures!.map((displayedFixture, i) => {
            const fixture : Fixture = displayedFixture.fixture;
            const displayed : boolean = displayedFixture.displayed;
            let formattedTimeUntil;
            if(fixture.scheduledStartTime) {
                const timeUntilStart : number = fixture.scheduledStartTime - new Date().getTime();
                formattedTimeUntil = this.timeFormatter(timeUntilStart);   
            }

            return (
                <ExpansionPanel key={fixture.id} CollapseProps={{ unmountOnExit: true }} expanded={displayed} style={{backgroundColor:"transparent"}}>
                    <ExpansionPanelSummary
                        aria-controls="panel1a-content"
                        onClick={() => this.props.fixtureClicked(fixture.id)}>
                        <FixtureListElementView key={fixture.id} fixture={fixture} />
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails key={`Expansion Panel Details ${fixture.id}`} style={{display: "flex"}}>
                        <div className="fixture-accordion-details">
                            FixtureID: {fixture.id} <br/>

                            CompetitionID: {fixture.competition.id} <br/>

                            {fixture.status === "Scheduled" && <span>TeamIDs: {fixture.participants[0].name} ({fixture.participants[0].id}) - {fixture.participants[1].name} ({fixture.participants[1].id}) </span>}
                            
                            {fixture.status === "Scheduled" && fixture.sport.alias === "cs2" && formattedTimeUntil && <span>{`Waiting for the match to start... (${formattedTimeUntil})`}</span>}
                            {fixture.sport.alias === "cs2" && <FixtureScoreboardContainer id={fixture.id} summary={fixture}  legacy={new URLSearchParams(window.location.search).get('v1')?.toLocaleLowerCase() === "true"} {...this.state} displaySelf={() => this.props.fixtureClicked(fixture.id, true)}/>}
                        </div>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            );
        });

        let sportAlias = this.props.fixtures[0].fixture.sport.alias;
        let properAlias = (function (alias) {
            switch (alias.toLowerCase()) {
                case "aov":
                    return "Arena of Valor";
                case "cod":
                    return "Call of Duty";
                case "codmobile":
                    return "Call of Duty: Mobile";
                case "codmwii":
                    return "Call of Duty: Modern Warfare 2";
                case "codvg":
                    return "Call of Duty: Vanguard";
                case "codwz":
                    return "Call of Duty: Warzone";
                case "csgo":
                    return "Counter-Strike: Global Offensive";
                case "dota2":
                    return "Dota2";
                case "hearthstone":
                    return "Hearthstone";
                case "hok":
                    return "Honor of Kings";
                case "hots":
                    return "Heroes of the Storm";
                case "lol":
                    return "League of Legends";
                case "ow":
                    return "Overwatch";
                case "r6":
                    return "Rainbow Six Siege";
                case "rl":
                    return "Rocket League";
                case "valorant":
                    return "Valorant";
                case "wildrift":
                    return "Wild Rift";
                case "mlbb":
                    return "Mobile Legends: Bang Bang";
                case "cs2":
                    return "Counter-Strike 2";
                case "codmwiii":
                    return "Call of Duty: Modern Warfare 3";
                default:
                    return sportAlias;
            }
        })(sportAlias);

        return (
            <div>
                <div className={"competitionHeader"}>
                    <div style={{ fontWeight: 700, display: "inline-block" }}>{properAlias}</div>
                    &nbsp;-&nbsp;
                    <div style={{ display: "inline-block" }}>{this.props.competitionName}</div>
                </div>
                {fixtures}
            </div>
        )
    }
}